import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles';

const styles = {
	parent: {
		display: 'flex'
	},
	child: {
		flex: 1,
		width: 1,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'noWrap'
	}
};

const CellText = ({classes, children}) => (
	<span className={classes.parent}>
		<span className={classes.child}>
			{children}
		</span>
	</span>
);

CellText.propTypes = {
	classes: PropTypes.object.isRequired,
	children: PropTypes.node.isRequired
};

export default withStyles(styles)(CellText);



// WEBPACK FOOTER //
// ./src/client/components/admin/common/cell-text/index.jsx